/* 
 	* 指令下发组件 
 	* 描述：Golox设备日志下载指令下发
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>开始时间</label>
			    <div class="col-sm-8">
			       <datepicker v-model="startDate" class="form-control" :options="localeOption"></datepicker>
			    </div>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>结束时间</label>
			    <div class="col-sm-8">
			       <datepicker v-model="endDate" class="form-control" :options="localeOption"></datepicker>
			    </div>
		    </div>	
		    <div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>
    </div>	
</template>
<script>
	import { zh } from 'flatpickr/dist/l10n/zh';
    import Datepicker from 'components/common/datepicker/Datepicker'
	export default {
		name: "InsGoloxLoading",
		components: {
			Datepicker
		},
		data() {
			return {	
				localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
				startDate :"",             //开始时间
				endDate :"",                //结束时间
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {
			resetInput(){
				this.startDate = ''
				this.endDate = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				if(!this.startDate ||!this.endDate){
					 this.alertMsg = "开始时间或结束时间不能为空";
					 return;
				}
				if(this.startDate > this.endDate){
				    this.alertMsg = "开始时间不得大于结束时间";
					return ;
			      }else if(this.startDate == this.endDate){
				  	this.alertMsg = "开始时间不得等于结束时间";
				  	return;
			    }else{
			    	this.alertMsg = "";
			    }
				let arr = ['SETPRM',12,this.startDate,this.endDate]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InsGoloxLoading.vue?ea02f67c